<template>
  <div class=" is-fullwidth">
    <div class="container is-fullwidth is-pulled-right">
        <div class="columns">
         <div class="col is-pulled-left">
           <button class="button is-link mr-4" v-if="loading===false">Displaying {{ filteredOrders.length }} orders</button>
           <button class="button" :class="{ 'is-success': filterStrabaneOffshore }" @click="filterStrabaneOffshore = !filterStrabaneOffshore" style="margin-right: 1rem;">Strabane → Offshore</button>
         </div>
          
          <div class="col">
        <input class="input" v-model="search" placeholder="search orders ..."/>
          </div>
          <div class="col">
            <div class="select">
        <select  v-model="selected_artworker_user_id">
                  <option value="">Filter By Designer</option>
                  <option v-bind:value="row.userID" v-for="row in artworkers" :key="row.userID">{{ row.firstname }} {{row.surname }}</option>
                  
          </select>
          </div>
          </div>
          </div>
          <br />
    </div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Qty</th>
          <th>CAD ID</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Artworker</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Gerber</th>
          <th >&nbsp;</th>
          </tr>
    	</thead>
    	<tbody>
         <tr v-if="loading === true">
                <td colspan="12" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="12" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
		    <tr v-for="order in filteredOrders" v-bind:key="order.orderID" >
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
              <td ><router-link :to="'/digitalprint/view-order?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</router-link></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{order.cad_id}}</td>
          <td>{{ (order.orderdate_iso || '').slice(0, 10) }}</td>
          <td>{{ (order.deliverydate_iso || '').slice(0, 10) }}</td>
          <td>
              <span v-if="artworkManager == true">
                <select class="select" v-model="order.artworker_user_id" @change="assignArtworker(order)">
                        <option value="0">Please select</option>
                        <option v-bind:value="row.userID" v-for="row in artworkers" :key="row.userID">{{ row.firstname }} {{row.surname }}</option>
                       
                </select>

              </span>
              <div v-if="artworkManager == false" >
                
                <button class="button is-small is-primary" @click="assignArtworkerSelf(order)" :disabled="working===true" v-if="order.artworker_user_id == 0" >Choose</button>
                 <div v-if="order.artworker_user_id > 0" >{{ order.artworker_firstname }} {{order.artworker_surname}}</div>
              </div>

          </td>

         <td>
               <button class="button is-small is-success"   v-if="order.print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.print_location_id==2">Giurgiu</button>
                  <button class="button is-small is-warning"   v-if="order.print_location_id==26">Metropolis</button>

                  <button class="button is-small is-danger"   v-if="order.print_location_id=='' || order.print_location_id==null">Not Set</button>
               
           </td>
           <td>
               <button class="button is-small is-success"   v-if="order.fabric_print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.fabric_print_location_id==2">Giurgiu</button>
                  <button class="button is-small is-warning"   v-if="order.fabric_print_location_id==26">Metropolis</button>

                  <button class="button is-small is-danger"   v-if="order.fabric_print_location_id=='' || order.fabric_print_location_id==null">Not Set</button>
               
           </td>
           <td>
               <button class="button is-small is-success"   v-if="order.gerber_print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.gerber_print_location_id==2">Giurgiu</button>
                  <button class="button is-small is-warning"   v-if="order.gerber_print_location_id==26">Metropolis</button>

                  <button class="button is-small is-danger"   v-if="order.gerber_print_location_id=='' || order.gerber_print_location_id==null">Not Set</button>
               
           </td>
          
              <td >
                  <button class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-if="order.artworker_user_id > 0 && (artworkManager == true || current_user_email == order.artworker_email)">Finished</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" class="button is-link">Export to Excel</button>
    
    <OrderModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"/>


    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderModal from '@/components/OrderModal';
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	OrderModal
  },
  mixins: [OrderMixin],
  data() {
    
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading:true,
      locations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      artworkers: [],
      selected_artworker_user_id: '',
      current_user_email : this.$auth.user.email,
      order_by: 'deliverydate ASC',
      search: '',
      filterStrabaneOffshore: false
      
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getNewArtworkOrders(this.accessToken, "", this.selected_artworker_user_id, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async getArtworkers() {
        UtilityService.getSimpleApiData(this.accessToken, "users?artworker=1").then(
               response => this.artworkers = response 
            );
      },
      
    
      exportXLS() {
      //alert("hi")
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"New Artwork"});
      XLSX.writeFile(wb, 'new_artwork.xlsx')

    },

    async processOrder(order) {
        this.working = true

        var formdata = { 
            _method: 'patch',
             artwork_finished: 1
        }; 

        OrderService.updateOrder(this.accessToken, order.orderID, formdata)
        .then(() => {
            order.artwork_finished = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async assignArtworkerSelf(order) {
        this.working = true

        if(confirm("Are you sure you want to assign this job to yourself ?"))
        {

          var formdata = { 
              _method: 'patch',
              artworker_user_id: "self"
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
          .then((response) => {
              order.artworker_user_id = response.artworker_user_id
              order.artworker_firstname = response.artworker_firstname
              order.artworker_surname = response.artworker_surname
              order.artworker_email = response.artworker_email
              this.working = false
              //console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else{
          this.working = false
        }
    },
    async assignArtworker(order) {
        this.working = true
        var questionText = "Are you sure you want to assign this job ?";

        if(order.artworker_user_id == 0 || order.artworker_user_id == "")
        {
          questionText = "Are you sure you want to un-assign this job?";
        }

        if(confirm(questionText))
        {

          var formdata = { 
              _method: 'patch',
              artworker_user_id: order.artworker_user_id
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
          .then((response) => {
              //order.artworker_user_id = response.artworker_user_id
              //order.artworker_firstname = response.artworker_firstname
             // order.artworker_surname = response.artworker_surname
              this.working = false
              console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else{
          order.artworker_user_id = 0
          this.working = false
        }
    }
    
  },
  computed : {
     filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.artwork_finished == 0)
            {
                return 1
            }
          })

          if(this.filterStrabaneOffshore) {
            filteredOrders = filteredOrders.filter(order => 
              order.print_location_id == 1 && order.gerber_print_location_id != 1
            )
          }

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }
          

          return filteredOrders
       
     },
     artworkManager: function() {
       return this.$auth.user.roles.includes("Artwork Manager")
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getPrintLocations();
           this.getArtworkers();

           //console.log(this.$auth.user.email)
        });
  },
 
  mounted() {
    if (localStorage.selected_artworker_user_id) {
      this.selected_artworker_user_id = localStorage.selected_artworker_user_id;
    }

    
  },
  watch: {
    selected_artworker_user_id: function () {
      localStorage.selected_artworker_user_id = this.selected_artworker_user_id;
      this.orders = []
      this.getOrders();
      
    },
  }
}


</script>

